// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1-VtG","label":"Radio_label__2Z8OK","checkMark":"Radio_checkMark__1ItwB","disabled":"Radio_disabled__98fx0"};